import { FC, HtmlHTMLAttributes } from 'react';
import Typography from '../Typography';

type Props = HtmlHTMLAttributes<HTMLHeadingElement> & {
	// Quando este é o título principal da rota, passe "h1": o nível muda sem
	// alterar o visual (a escala tipográfica vem da variant, não da tag).
	asEl?: 'h1' | 'h2';
};

const SectionTitle: FC<Props> = ({ children, className, asEl = 'h2', ...props }) => {
	return (
		<Typography variant="headline-5" sm='headline-3' lg="headline-1" asEl={asEl} className={className} {...props}>
			{children}
		</Typography>
	);
};

export default SectionTitle;
